module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_4.b9f86d59.png";